module.exports = __webpack_public_path__ + "static/media/AccaOpenLogo.c640ac36.svg";